import {
    JobPositionSchedule,
    JobPositionType,
} from "@sr-partner-portal/common";

export const jobPositionNameMap = {
    [JobPositionType.EMPLOYEE]: "Job",
    [JobPositionType.TRAINEE]: "Ausbildung",
    [JobPositionType.DUAL_STUDENT]: "Duales Studium",
};

export const jobScheduleNameMap = {
    [JobPositionSchedule.FULL_TIME]: "Vollzeit",
    [JobPositionSchedule.PART_TIME]: "Teilzeit",
    [JobPositionSchedule.RANGE]: "Spanne",
};
